<template>
  <v-dialog
    v-model="getTariffAddModal"
    width="400"
    content-class="add-head-modal"
  >
    <v-card class="pt-11 pb-13 px-8 rounded-xl elevation-0 bg_sidebar">
      <p class="mb-6 font-20px dark-color--text">{{ $t("Tariffs.create_tariff") }}</p>
      <div>
        <label class="mb-4 label sub--text">{{ $t("Owners.tariff_name") }}</label>
        <v-text-field
          solo
          outlined
          flat
          class="focus-input"
          hide-details="false"
          height="44px"
          v-model="forms.name"
        />
      </div>
      <div class="mt-5">
        <label class="mb-4 label sub--text">{{ $t("Owners.employees_count") }}</label>
        <v-text-field
          solo
          outlined
          flat
          class="focus-input mask-number"
          hide-details="false"
          height="44px"
          type="number"
          v-model="forms.max_employees_qty"
        />
      </div>
      <div class="tariff-tab-2 mt-5">
        <label class="mb-4 label sub--text">{{ $t("Tariffs.month_price") }} KZT</label>
        <v-text-field
          solo
          outlined
          flat
          class="focus-input mask-number"
          hide-details="false"
          height="44px"
          type="number"
          v-model="forms.month_price"
        />
      </div>
      <div class="mt-10">
        <v-btn
          width="100%"
          height="44px"
          elevation="0"
          hide-selected="true"
          class="button"
          color="main_color white--text"
          @click="addTariff"
        >
          {{ $t("Default.save") }}
        </v-btn>
        <v-btn
          width="100%"
          height="44px"
          elevation="0"
          hide-selected="true"
          class="button mt-2"
          color="sub white--text"
          @click="getTariffAddModal = false"
        >
          {{ $t("Default.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import {ref} from "@vue/composition-api";
import {shortComputed} from "@/utility/helpers";
import {useStore} from "vuex-composition-helpers";
import {MutationTypes, DispatchTypes} from "@/store/modules/admin/tariffs/types";
import {VARIABLES} from "@/utility/variables";
import {forms} from "../index";

export default {
  name: "getTariffAddModal",
  setup(props, {root}) {
    const store = useStore();
    const items = ["Ежемесячно", "Ежегодно"];
    const tab = ref(VARIABLES.DEFAULT_TAB);
    const getTariffAddModal = shortComputed(
      {
        storeType: "tariffs",
        key: "getTariffAddModal",
      },
      MutationTypes.setTariffAddModal
    );

    const addTariff = () => {
      store.dispatch(DispatchTypes.addTariff, forms).then(() => {
        store.commit(MutationTypes.setTariffAddModal, false);
      });
    };

    return {
      store,
      getTariffAddModal,
      items,
      tab,
      forms,
      addTariff,
    };
  },
};
</script>
